import React, { useEffect, useRef } from 'react';
import { useCarousel, TRIGGER } from './state';

export const isAboveFold = (ele: Element) => {
  // preventing unintended down-scrolling upon page loading.
  const eleRect = ele.getBoundingClientRect();
  return window.innerHeight - eleRect.top > eleRect.height * 0.6;
};

export interface ItemProps {
  children: React.ReactElement | React.ReactElement[] | string;
  className?: string;
  index?: number;
  timeoutTime?: number;
  qeId?: string;
}

const Item = ({
  children,
  className,
  index,
  timeoutTime = 0,
  qeId = 'Item',
}: ItemProps): React.ReactElement => {
  const [state] = useCarousel();
  const itemRef = useRef<HTMLLIElement>(null);
  const { currentIndex, triggerType } = state;

  useEffect(() => {
    const itemEle = itemRef && itemRef.current;
    const isDotTrigger = triggerType === TRIGGER.DOT;

    /* istanbul ignore next */
    if (
      index === currentIndex &&
      itemEle &&
      isAboveFold(itemEle) &&
      isDotTrigger
    ) {
      // without setTimeout carousel generates blank slides under certain conditions.
      setTimeout(() => {
        itemEle.focus({ preventScroll: true });
      }, timeoutTime);
    }
  }, [currentIndex, index, timeoutTime, triggerType]);

  return (
    <li
      data-testid={
        currentIndex === index ? `active-el-${index}` : `inactive-el-${index}`
      }
      key={`${qeId}-${index}`}
      ref={itemRef}
      className={className}
      style={{
        flexGrow: 1,
        padding: 0,
        margin: 0,
        width: `${100 / state.totalItems}%`,
      }}
      tabIndex={-1}
    >
      {children}
    </li>
  );
};

export default Item;
